export function getCandidateName(firstName: string, lastName: string): string {
  return `${lastName || ''} ${firstName || ''}`;
}
